var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossIconDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "12px",
    height: "12px",
    viewBox: "0,0,255.98958,255.98958",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.00521,-0.00521) scale(21.33333,21.33333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Iconography"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-836,-1837)",
    id: "DG---TieOut-Iconography"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(831,1832)",
    id: "Icons-/-Functional-/-Cross-/-Special-<-24px"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Functional-/-Cross-Copy-5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 22,
    height: 22,
    id: "Bounding-Box",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.5,5.5)",
    id: "close",
    fill: "#c9c9c9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.10398,5.46037l4.68012,-4.68149c0.17764,-0.17764 0.17764,-0.4646 0,-0.64224c-0.17764,-0.17764 -0.4646,-0.17764 -0.64224,0l-4.68149,4.68012l-4.68012,-4.68012c-0.17764,-0.17764 -0.46596,-0.17764 -0.6436,0c-0.17764,0.17764 -0.17764,0.4646 0,0.64224l4.68012,4.68149l-4.68012,4.68012c-0.17764,0.17764 -0.17764,0.46596 0,0.6436c0.08882,0.08882 0.20497,0.13268 0.32125,0.13268c0.11738,0 0.23353,-0.04386 0.32235,-0.13268l4.68012,-4.68149l4.68149,4.68149c0.08896,0.08882 0.20497,0.13268 0.32112,0.13268c0.11615,0 0.23243,-0.04386 0.32112,-0.13268c0.17764,-0.17764 0.17764,-0.46596 0,-0.6436z"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIconDisabled);
export default __webpack_public_path__ + "static/media/cross-icon-disabled.fd812ad23be82d20fd79d98c6b2fb7ec.svg";
export { ForwardRef as ReactComponent };